import React from 'react';
import { Query } from '@apollo/client/react/components';

import LoadingProgress from 'lib/react-router/loading-progress';

import ErrorPage from 'four-nets/errors/error-page';

import query, { CatalogQuery } from './catalog-navigation.graphql';
import CatalogNavigation from './catalog-navigation';

type CatalogCategoriesEdges = NonNullable<NonNullable<CatalogQuery['catalogCategories']>['edges']>;
type CatalogCategoriesGroupNodeEdge = NonNullable<
    NonNullable<NonNullable<CatalogQuery['catalogCategoryGroups']>['edges']>
>;

interface Props {
    mini?: boolean;
    slug?: string;
    parentCategories?: boolean;
    hideNotSelected?: boolean;
}

const createRowsAndColumns = (edges: CatalogCategoriesGroupNodeEdge) => {
    const result = [] as string[][];

    edges.forEach(edge => {
        if (edge && edge.node && edge.node.name && edge.node.row !== null && edge.node.column !== null) {
            while (result.length - 1 < edge.node.column) {
                result.push([]);
            }
            while (result[edge.node.column].length - 1 < edge.node.row) {
                result[edge.node.column].push('');
            }
            result[edge.node.column][edge.node.row] = edge.node.name;
        }
    });

    return result;
};

class CatalogNavigationLoader extends React.PureComponent<Props, {}> {
    static defaultProps = {
        parentCategories: true,
    };

    render() {
        const { parentCategories, mini, slug, hideNotSelected } = this.props;

        return (
            <Query<CatalogQuery> query={query}>
                {({ data, loading, error }) => {
                    if (
                        !(
                            data &&
                            data.catalogCategories &&
                            data.catalogCategoryGroups &&
                            data.catalogCategories.edges &&
                            data.catalogCategoryGroups.edges
                        )
                    ) {
                        return null;
                    }

                    const edges = data.catalogCategories.edges!;
                    const groups = data.catalogCategoryGroups.edges!;

                    const grid = createRowsAndColumns(groups);

                    const categoriesByParent: Map<string, CatalogCategoriesEdges> = new Map();
                    if (edges) {
                        edges.forEach(edge => {
                            const parentCategory =
                                edge && edge.node && edge.node.parentCategory && edge.node.parentCategory.name;
                            if (parentCategory) {
                                if (!categoriesByParent.has(parentCategory)) {
                                    categoriesByParent.set(parentCategory, []);
                                }
                                categoriesByParent.get(parentCategory)!.push(edge);
                            }
                        });
                    }

                    let activeCategoryPosition: number[] = [];
                    edges.forEach(edge => {
                        if (edge && edge.node && edge.node.slug === slug) {
                            activeCategoryPosition = [
                                (edge.node.parentCategory && edge.node.parentCategory.column) || 0,
                                (edge.node.parentCategory && edge.node.parentCategory.row) || 0,
                            ];
                        }
                    });

                    return (
                        <LoadingProgress loading={loading}>
                            <ErrorPage error={error}>
                                <CatalogNavigation
                                    mini={mini}
                                    hideNotSelected={hideNotSelected}
                                    parentCategories={parentCategories}
                                    categoriesByParent={categoriesByParent}
                                    initialActiveCategoryPosition={activeCategoryPosition}
                                    categories={grid}
                                />
                            </ErrorPage>
                        </LoadingProgress>
                    );
                }}
            </Query>
        );
    }
}

export default CatalogNavigationLoader;
